import * as globals from '../globals'
import * as apiService from './apiService'
import { getMeta } from '../utils/metaUtils'
import { getPriceLevelLabels } from '../utils/dcmUtils'
import { guid } from '../utils/guid'
import { LabelList } from 'recharts'
import { actionCreators as GlobalStoreCreator } from '../store/General'

//need to update - study to dcm.configs...
export const aggregate = (data, level, study) => {
  if (!data) return null

  const config = study.config

  // find next higher
  const aggLevels = [
    ...study.selectionHierarchy,
    { name: 'product', label: study.productLabel },
  ]
  const sectionName = aggLevels[0].name

  if (level === 'product') {
    return config.productSlots.map((slot) => ({
      uid: slot.uid,
      product: slot.uid,
      label: slot.label,
      section: slot.play[sectionName],
      data: data[slot.uid],
    }))
  }

  // find level att
  const att = config.productDefs.default.atts.find((a) => a.name === level)
  if (!att) return null

  const levels = att.levels
  if (!levels) return null

  let rows = levels.map((lev) => {
    // find products that match the selections level
    const aggProducts = config.productSlots.filter(
      (slot) => slot.play[level] == lev.value
    )

    let slot = aggProducts.length > 0 ? aggProducts[0] : null

    let retVal = {
      uid: `${att.name}:${lev.value}`,
      [att.name]: lev.value,
      label: lev.label,
      section: slot ? slot.play[sectionName] : null,
      data: { play: {}, base: {} },
    }
    globals.metrics.forEach((metric) => {
      let play_accum = null
      let base_accum = null
      aggProducts.forEach((p) => {
        let play_val =
          data[p.uid] && data[p.uid].play ? data[p.uid].play[metric.key] : null
        let base_val =
          data[p.uid] && data[p.uid].base ? data[p.uid].base[metric.key] : null
        if (metric.aggMethod === 'sum') {
          if (play_val) play_accum = (play_accum || 0) + play_val
          if (base_val) base_accum = (base_accum || 0) + base_val
        } else if (metric.aggMethod === 'max') {
          if (play_val)
            play_accum = play_accum ? Math.max(play_accum, play_val) : play_val
          if (base_val)
            base_accum = base_accum ? Math.max(base_accum, base_val) : base_val
        }
      })
      retVal.data.play[metric.key] = play_accum
      retVal.data.base[metric.key] = base_accum
    })
    return retVal
  })
  return rows
}

export const computeModel = async (studyId, auth, payload, etag, model) => {
  const config = payload?.config
  const filter = payload?.filter || '1==1'
  const brandvalues = payload.brandvalues || []
  const activeConfig = payload?.activeConfig

  let attLookups = null
  const fetchMeta = async () => {
    let lookups = await getMeta(
      studyId,
      auth,
      model?.modelInfo.attConditionsLookups
    )
    if (lookups) {
      attLookups = lookups
    }
  }

  if (model?.modelInfo.attConditionsLookups?.length > 0) await fetchMeta()

  const levelLabels = await getPriceLevelLabels(config.play, attLookups)
  const costs = await getMeta(studyId, auth, 'levelcosts')

  const query = {
    studyId,
    uFilter: filter.syntax,
    uFilterName: filter.name,
    config,
    modelInfo: payload?.modelInfo,
    brandvalues,
    //etag: etag ?? guid()
    playHash: etag,
    levelLabels,
    levelcosts: costs,
  }

  // console.log('FILTER SYNTAX', query.uFilter);
  // console.log('query', query);

  const url = `${globals.apiRoot}/compute/model`
  try {
    const response = await apiService.aPost(auth, url, query)
    // console.log('response', response)
    if (!response.ok) {
      console.error(response)
      return null
    }
    const results = await response.json()
    //return results as 2024:{ suv:{prod1:{}}

    return {
      [activeConfig]: {
        ...results,
      },
    }
    //return value
  } catch (err) {
    console.error('computeModel error', err)
    return null
  }
}

export const computeFordModel = async (studyId, auth, payload) => {
  //payload needs to have playHash
  const config = payload?.config //products
  const brandvalues = payload?.brandvalues || []

  let modelFilters = payload?.filter
  if (!Array.isArray(modelFilters)) {
    modelFilters = [modelFilters]
  }
  // console.log('modelfilters', modelFilters);

  const filterName = payload?.filter?.name
  const metaKey = payload?.modelInfo?.attConditionsLookups

  let attLookups = null
  const fetchMeta = async () => {
    let lookups = await getMeta(studyId, auth, metaKey)
    if (lookups) {
      attLookups = lookups
    }
  }

  if (metaKey?.length > 0) await fetchMeta()

  const levelLabels = attLookups
    ? await getPriceLevelLabels(config?.play, attLookups)
    : []
  const costs = attLookups ? await getMeta(studyId, auth, 'levelcosts') : {}

  const _query = {
    studyId,
    etag: payload?.etag,
    // uFilter: filter.syntax,
    uFilterName: filterName,
    config,
    modelInfo: payload?.modelInfo,
    brandvalues,
    playHash: payload?.playHash || '', // ?? guid()
    levelLabels,
    levelcosts: costs || {},
  }

  // console.log('FILTER SYNTAX', query.uFilter);
  console.log('FORD FORECAST computeFordModel query', _query)
  // dispatch({type: 'FORD_FORECAST_REQUEST', modelName: payload.modelInfo?.name, playHash: payload?.playHash, filterName: filterName})

  const url = `${globals.apiRoot}/compute/model`

  const makeRequest = async (query, retries = 3) => {
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        const response = await apiService.aPost(auth, url, query)

        if (response.status === 400) {
          console.warn(`400 ERROR occurred (Attempt ${attempt} of ${retries})`)
          if (attempt === retries)
            throw new Error('Max retries reached for 400 errors')
          continue // Retry
        }

        // If response is successful, parse and return the data
        const data = await response.json()
        return data
      } catch (err) {
        if (attempt === retries) {
          console.error(`Final attempt failed after ${retries} retries`, err)
          throw err
        }
        console.warn(`Retrying request (Attempt ${attempt} of ${retries})`, err)
      }
    }
  }

  try {
    let modelData = null

    for (let modelFilter of modelFilters) {
      const query = {
        ..._query,
        uFilter: modelFilter.syntax,
      }

      // let response = await apiService.aPost(auth, url, query)
      // if (response.status === 400) {
      //     console.log('400 ERROR occured and we retried again');
      //     response = await apiService.aPost(auth, url, query)
      // }
      // let data = await response.json()
      // data = data?.[filterName]
      let data = await makeRequest(query)
      data = data?.[filterName]

      // console.log('modelFilter.productIds?.length', modelFilter.productIds?.length);

      if (data && modelFilter.productIds?.length) {
        const newData = {}
        for (let uid of modelFilter.productIds) {
          newData[uid] = data[uid]
        }
        data = newData
      }

      if (data) {
        modelData = {
          ...modelData,
          ...data,
        }
      }

      return modelData
    }
  } catch (err) {
    console.error('Error during forecast computation:', err)
    return null
  }
}

// try {
//         const response = await apiService.aPost(auth, url, query)
//         // console.log('response', response)
//         if (!response.ok) {
//             console.error(response)
//             return null
//         }
//         const results = await response.json()
//         //return results as 2024:{ suv:{prod1:{}}

//         return {
//             [activeConfig]: {
//                 ...results
//             }
//         }
//         //return value
//     } catch (err) {
//         console.error("computeModel error", err)
//         return null
//     }
